import { useState, useEffect } from "react";
import Modal from "../shared/Modal";
import { ModalMatchingEmployees } from "../personas/ModalMatchingEmployees";

import "./ModalEmployeeResourceSearch.css";
import { Employee, getDefaultUserAvatar } from "winslow-core";

interface ModalEmployeeResourceSearchProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (employeeId: string) => void;
  employees: Employee[];
}

export const ModalEmployeeResourceSearch: React.FC<
  ModalEmployeeResourceSearchProps
> = ({ isOpen, onClose, onSelect, employees }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showEmployeeList, setShowEmployeeList] = useState(false);

  const filteredEmployees = employees.filter((employee) =>
    employee.displayName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpen) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{ width: "672px" }}
      canClose={true}
      escapeToClose={true}
      allowClickout={true}>
      <div className="employee-search-modal">
        <div className="employee-search-header">
          <div className="employee-search-title-row">
            <h1 className="employee-search-title">Employee Resource Search</h1>
            <div
              className="employee-count"
              onClick={() => setShowEmployeeList(true)}
              style={{ cursor: "pointer" }}>
              {employees.length === 0
                ? "No Employees"
                : employees.length === 1
                  ? "1 Employee"
                  : `${employees.length} Employees`}
            </div>
          </div>
          <div className="employee-search-container">
            <label htmlFor="employeeSearch" className="visually-hidden">
              Search employees
            </label>
            <input
              id="employeeSearch"
              type="text"
              className="employee-search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search employees"
              aria-label="Search employees"
            />
            {searchTerm && filteredEmployees.length > 0 && (
              <div className="employee-results-container">
                {filteredEmployees.map((employee, index) => (
                  <div
                    key={employee.id}
                    className="employee-item"
                    onClick={() => {
                      onSelect(employee.id);
                      onClose();
                    }}>
                    <img
                      loading="lazy"
                      src={employee?.profile?.avatar || ""}
                      className="employee-avatar"
                      alt={getDefaultUserAvatar(employee.displayName)}
                    />
                    <div className="employee-info">
                      <div className="employee-name">
                        {employee.displayName || employee.email}
                      </div>
                      <div className="employee-role">
                        {employee.title || ""}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      <ModalMatchingEmployees
        isOpen={showEmployeeList}
        onClose={() => setShowEmployeeList(false)}
        employees={employees}
        title="All Employees"
      />
    </Modal>
  );
};
